import { lazy } from 'react';

/**
 * Wraps React.lazy with retry logic for failed chunk loads after deployments.
 * On failure, reloads the page once to get fresh HTML with new chunk references.
 */
export function lazyWithRetry(importFn) {
  return lazy(() =>
    importFn().catch(() => {
      const hasReloaded = sessionStorage.getItem('chunk_reload');
      if (!hasReloaded) {
        sessionStorage.setItem('chunk_reload', '1');
        window.location.reload();
        return new Promise(() => {});
      }
      sessionStorage.removeItem('chunk_reload');
      return importFn();
    })
  );
}
